import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "Vision", href: "#vision" },
  { label: "Our Story", href: "#story" },
  { label: "Approach", href: "#approach" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Founder", href: "#founder" },
  { label: "Blog", href: "#blog" },
  { label: "FAQ", href: "#faq" },
  { label: "Our Products", href: "#products" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#faf7f2]/90 backdrop-blur-xl border-b border-[#ebe5dc] shadow-sm" : "bg-transparent"
      }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#hero" className="flex items-center gap-2.5" data-testid="logo-link">
          <img src="https://static.prod-images.emergentagent.com/jobs/88bcfbb5-0f75-48df-9f1d-e41b46909d27/images/0eeae0691aca1cf5f4955a37311e488c07d17393c92e24100575d147c858c8fc.png" alt="Logo" className="w-9 h-9 object-contain" />
          <div className="flex flex-col">
            <span className="font-bold tracking-tight text-xl text-[#2a9d8f]" style={{ fontFamily: 'Fraunces, serif' }}>
              Bharat<span className="text-[#c4683c]">Intelli</span>AI
            </span>
            <span className="text-[7px] text-[#8a8078] tracking-wide leading-none">A brand of Rewat Intelliforge Technologies LLP</span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              className="text-sm font-medium text-[#5c564e] hover:text-[#2a9d8f] transition-colors duration-300">{link.label}</a>
          ))}
          <Link to="/new-minds" className="text-base font-bold text-[#c4683c] bg-[#c4683c]/8 border border-[#c4683c]/25 px-5 py-2 rounded-full hover:bg-[#c4683c]/15 transition-all flex items-center gap-2">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" /></svg>
            New Minds
          </Link>
        </nav>

        <a href="#contact" data-testid="header-cta-button"
          className="hidden lg:inline-flex bg-[#2a9d8f] text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-[#238b7f] transition-all duration-300">
          Get in Touch
        </a>

        <button data-testid="mobile-menu-toggle" onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden text-[#5c564e]">
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-[#faf7f2]/95 backdrop-blur-xl border-b border-[#ebe5dc] overflow-hidden">
            <nav className="flex flex-col px-6 py-4 gap-3">
              {navLinks.map((link) => (
                <a key={link.href} href={link.href} onClick={() => setMobileOpen(false)}
                  className="text-base text-[#5c564e] hover:text-[#2a9d8f] py-2 transition-colors">{link.label}</a>
              ))}
              <Link to="/new-minds" onClick={() => setMobileOpen(false)} className="text-base text-[#c4683c] font-semibold py-2">New Minds</Link>
              <a href="#contact" onClick={() => setMobileOpen(false)}
                className="bg-[#2a9d8f] text-white px-6 py-3 rounded-full text-sm font-bold text-center mt-2">Get in Touch</a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
